module.exports = __webpack_public_path__ + "static/media/cryptomania-white.fd7b06cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/cryptomania-white.svg
// module id = 754
// module chunks = 1